import React from 'react'
import { StyledJATOFormScreen } from './JATOFormScreen.styles'

export const JATOFormScreen: React.FC = () => (
  <StyledJATOFormScreen>
    <div className="splashScreen" />
  </StyledJATOFormScreen>
)
